import { download } from '@/utils/http'
import request from '@/utils/request'

/**
* 示例API
*
* @author Jay Qing
*/

/**
* 基础接口
*
* @type {string}
*/
const BASE_URL = '/demo/demo'

export const DOME_BASE_URL = BASE_URL

/**
* 分页查询接口
*
* @type {string}
*/
export const DEMO_PAGE_URL = `${BASE_URL}/page`

/**
 * 导出基本接口
 *
 * @type {string}
 */
export const EXPORT_BASE_URL = '/common/file'

/**
* 导入接口
*
* @type {string}
*/
export const IMPORT_URL = `${BASE_URL}/import`
/**
* 查询指定ID的数据
*
* @param id ID
* @returns {Promise}
*/
export function get(id: any) {
  return request({
    url: `${BASE_URL}/get/${id}`,
    method: 'get'
  })
}

/**
* 保存数据
*
* @param data 数据
* @returns {Promise}
*/
export function save(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

/**
* 更新数据
*
* @param data 数据
* @returns {Promise}
*/
export function demoUpdate(data: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}

/**
* 删除数据
*
* @param idList ID数组
* @returns {Promise}
*/
export function demoRemove(idList: any) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  })
}

/**
* 生成二维码
*
* @param text text
* @returns {Promise}
*/
export function getQrCode(text: any) {
  return request({
    url: `${BASE_URL}/qrCode/${text}`,
    method: 'get'
  })
}

/**
* 导出Excel
*
* @param query 查询条件
*/
export function exportExcel(query: any) {
  return download(`${BASE_URL}/export`, query)
}